<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <a-button type="primary" @click="pickUpOrder">{{$t('button.drawDraft')}}</a-button>
      <a-button type="primary" @click="pickUpInventory">{{$t('button.drawInventory')}}</a-button>
      <a-popconfirm
        :title="$t('title.selectedDetailsWillBeDeleted')"
        @confirm="del">
        <a-button type="primary">{{$t('button.delete')}}</a-button>
      </a-popconfirm>
      <a-button :disabled="this.disqualificationOrder.details.length===0" :loading="saveLoading" type="primary" @click="save">{{$t('button.save')}}</a-button>
      <a-button :disabled="this.disqualificationOrder.details.length===0" :loading="saveLoading" type="primary" @click="submit">{{$t('button.submit')}}</a-button>
      <a-button type="primary" @click="reset">{{$t('button.reset')}}</a-button>
    </a-space>
    <a-divider style="margin-top: 3px;margin-bottom: -1px"/>
    <a-row style="margin-top: 2px">
      <a-col :span="6">
        <a-space>
          <span>{{$t('span.orderNo')}}</span>
          <vxe-input v-model="disqualificationOrder.no" disabled style="width: 100%"/>
        </a-space>
      </a-col>
      <a-col :span="6">
        <a-space>
          <span>{{$t('span.owner')}}</span>
          <vxe-select v-model="disqualificationOrder.owner.id" :options="owners" placeholder="placeholder.owner" style="width: 100%" @change="onOwnerChange"/>
        </a-space>
      </a-col>
      <a-col :span="6">
        <a-space>
          <span>{{$t('span.proposer')}}</span>
          <vxe-input
            v-model="disqualificationOrder.submissionAdvice.operator"
            :editable="false"
            @click="()=>this.$refs.userModal.open()"/>
        </a-space>
      </a-col>
      <a-col :span="6">
        <a-space>
          <span>{{$t('span.applicationAdvice')}}</span>
          <vxe-input v-model="disqualificationOrder.submissionAdvice.content" style="width: 100%"/>
        </a-space>
      </a-col>
    </a-row>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      align="center"
      ref="table"
      :data="disqualificationOrder.details"
      :loading="loading"
      size="small"
      :height="scrollY"
      keep-source
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :checkbox-config="{trigger: 'row'}"
      :edit-rules="editRules"
      :edit-config="editConfig"
      :scroll-x="{enabled: true}"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="checkbox" width="40"/>
      <vxe-column field="sku.item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="sku.item.name" title="business.label.itemName"/>
      <vxe-column field="sku.pack.specification" title="business.label.specification"/>
      <vxe-column field="sku.pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="sku.pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="sku.lot.no" title="business.label.lotNo"/>
      <vxe-column field="sku.lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="sku.lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="sku.lot.manufacturer" title="business.label.manufacturer"/>
      <vxe-column field="location.no" title="business.label.locationNo">
      </vxe-column>
      <vxe-column field="sku.logicalStore.name" title="business.label.logicalStore" width="90"/>
      <vxe-column field="inventoryState" title="business.label.inventoryState">
        <template #default="{row}">
          {{inventoryStateData.find(item => item.ordinal === row.inventoryState).name}}
        </template>
      </vxe-column>
      <vxe-column :edit-render="{autofocus: '.vxe-input--inner'}" field="quantity" title="title.unqualifiedQuantity">
        <template #edit="{ row }">
          <vxe-input type="number"
                     v-model="row.quantity"
                     :min="1"
                     align="center"
                     placeholder=""/>
        </template>
      </vxe-column>
      <vxe-column field="reasons" title="business.label.reason" :edit-render="{autofocus: '.vxe-input--inner'}">
        <template #edit="{ row }">
          <vxe-input type="text"
                     v-model="row.reasons"
                     align="center"
                     placeholder=""/>
        </template>
      </vxe-column>
    </vxe-table>
    <InventoryModal ref="inventoryModal" @change="onInventoryChange"/>
    <disqualification-pickup-modal ref="disqualificationPickupModal" @change="onOrderChange"/>
    <UserModal ref="userModal" @change="onUserChange"/>
  </a-layout>
</template>

<script>
import Vue from 'vue'
import { OPERATOR, SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import { del, findAll, findEnum, post } from '@/api/Api'
import InventoryModal from '@/views/modal/InventoryModal.vue'
import Api from '@/api'
import UserModal from '@/views/modal/UserModal.vue'
import DisqualificationPickupModal from '@/views/quality/disqualification/DisqualificationPickupModal.vue'
import { DisqualificationOrder } from '@/api/dto/order/DisqualificationOrder'
import { OrderType } from '@/api/dto/common/OrderType'

export default {
  name: 'DisqualificationApply',
  components: {
    DisqualificationPickupModal,
    UserModal,
    InventoryModal
  },
  props: {
    'queryParam': {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      selectedRowKeys: [],
      selectedRows: [],
      data: [],
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      owners: [],
      saveLoading: false,
      inventoryStateData: [],
      disqualificationOrder: new DisqualificationOrder(),
      isNew: true,
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.8125),// 表格竖向滚动条
      editRules: {
        'quantity': [
          { required: true, min: 1, type: 'number', message: '数量需大于0' }
        ]
      },
      editConfig: { trigger: 'click', mode: 'cell', showStatus: true }
    }
  },
  mounted() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = res.result
      }
    })
    findEnum('InventoryState').then(res => {
      if (res.success) {
        this.inventoryStateData = res.result
      }
    })
  },
  methods: {
    onOwnerChange() {
      if (this.data.length !== 0) {
        this.data = []
      }
    },
    pickUpOrder() {
      let args = { orderStatus: 0 }
      this.$refs.disqualificationPickupModal.open(args)
    },
    pickUpInventory() {
      if (this.disqualificationOrder.owner.isNew()) {
        return this.$message.warning('请先选择货主')
      }
      let args = { 'owner.id': this.disqualificationOrder.owner.id, available: true, physical: true }
      this.$refs.inventoryModal.open(args)
    },
    del() {
      let selectedRows = this.$refs.table.getCheckboxRecords()
      if (selectedRows.length === 0) {
        return this.$message.warning('请选中需要删除的明细')
      }
      this.loading = true
      let newDetails = []
      let oldDetails = []
      selectedRows.forEach(detail => {
        if (detail['isNew']) {
          newDetails.push(detail)
        } else {
          oldDetails.push(detail)
        }
      })
      newDetails.forEach(item => {
        this.disqualificationOrder.details.splice(this.disqualificationOrder.details.indexOf(item), 1)
      })
      if (oldDetails.length > 0) {
        let ids = []
        oldDetails.forEach(row => {
          ids.push(row.id)
        })
        del(Api.deleteAll, { type: 'disqualificationDetailDeleter' }, { ids: ids }).then(res => {
          if (res.success) {
            oldDetails.forEach(item => {
              this.disqualificationOrder.details.splice(this.disqualificationOrder.details.indexOf(item), 1)
            })
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.loading = false
      }
    },
    async save() {
      if (!this.verify()) {
        return
      }
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      this.loading = true
      this.saveLoading = true
      let order = Object.assign({}, this.disqualificationOrder)
      order.orderType = Object.assign(new OrderType(), { id: '160465299032371213', name: '不合格报损单' })
      order.warehouse = this.warehouse
      order.operator = this.operator.name
      post(Api.conversionQualifierSave, null, order).then(res => {
        if (res.success) {
          res.result.details.forEach(detail => {
            detail.isNew = false
          })
          Object.assign(this.disqualificationOrder, res.result)
          this.$message.success('保存成功')
        }
      }).finally(() => {
        this.loading = false
        this.saveLoading = false
      })
    },
    async submit() {
      if (!this.verify()) {
        return
      }
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      this.loading = true
      this.saveLoading = true
      let order = Object.assign({}, this.disqualificationOrder)
      order.orderType = Object.assign(new OrderType(), { id: '160465299032371213', name: '不合格报损单' })
      order.warehouse = this.warehouse
      order.operator = this.operator.name
      post(Api.conversionQualifierSubmit, null, order).then(res => {
        if (res.success) {
          this.reset()
          this.$message.success('提交成功')
        }
      }).finally(() => {
        this.loading = false
        this.saveLoading = false
      })
    },
    reset() {
      this.disqualificationOrder = new DisqualificationOrder()
    },
    onOrderChange(orderData) {
      orderData.details.forEach((detail) => {
        detail.isNew = false
      })
      Object.assign(this.disqualificationOrder, orderData)
    },
    onInventoryChange(inventoryData) {
      this.loading = true
      let details = []
      inventoryData.forEach(item => {
        let detail = {
          sku: {
            id: item.sku.id,
            item: item.item,
            pack: item.pack,
            lot: item.lot,
            logicalStore: item.logicalStore
          },
          container: item.container,
          location: item.location,
          inventoryState: item.inventory.inventoryState,
          quantity: 0,
          isNew: true
        }
        details.push(detail)
      })
      this.disqualificationOrder.details = details
      this.loading = false
    },
    onUserChange(user) {
      if (user.length > 0) {
        this.disqualificationOrder.submissionAdvice.operator = user[0].name
      } else {
        this.disqualificationOrder.submissionAdvice.operator = ''
      }
    },
    verify() {
      let pass = true
      let operator = this.disqualificationOrder.submissionAdvice.operator
      if (operator === null || operator === '' || operator === undefined) {
        pass = false
        this.$message.warning('申请人不能为空')
        return pass
      }
      return pass
    }
  }
}
</script>
<style scoped>
.columnHeader {
  font-weight: bold;
  color: #404040;
}
</style>